import { APP_INITIALIZER, inject } from '@angular/core';
import { ABP, RoutesService } from '@abp/ng.core';
import { ManageProfileTabsService } from '@volo/abp.ng.account/public/config';
import { ProfilePictureComponent } from '../profile-picture.component';


export const PROFILE_PICTURE_ROUTE_PROVIDER = [
  {
    provide: APP_INITIALIZER,
    useFactory: configureRoutes,
    deps: [ManageProfileTabsService],
    multi: true,
  }
];

function configureRoutes(tabs: ManageProfileTabsService) {


  return () => {
      tabs.patch("AbpAccount::ProfileTab:Picture", 
        {
          name: "Foto do perfil", 
          order: 1,
          component: ProfilePictureComponent,
        },
      );
      };
}
